import styled from 'styled-components/macro';
import { ActionIconButton } from '@redislabsdev/redis-ui-components';

export const PlusButton = styled(ActionIconButton)`
  margin-inline-start: auto;
`;
